import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./GreenBenefits.css";

const cards = [
  {
    icon: <img src="/icons/robot.webp" alt="Efficiency" />,
    title: "INCREASED EFFICIENCY AND PRODUCTIVITY",
    desc: "Streamline your processes, optimize your resource allocation, and facilitate data-driven decision-making."
  },
  {
    icon: <img src="/icons/computer.webp" alt="Sustainability" />,
    title: "ENHANCED SUSTAINABILITY IMPACT",
    desc: "Maximize the positive environmental impact of your solutions through data analysis and insights."
  },
  {
    icon: <img src="/icons/human.webp" alt="Engagement" />,
    title: "STRONGER CUSTOMER ENGAGEMENT",
    desc: "Develop interactive platforms and applications to engage your customers and promote eco-conscious behavior."
  }
];

export default function GreenBenefits({ imageSrc }) {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <section className="green-benefits-section" id="benefits">
      <div className="container">
      <div className="green-benefits-top">
        <div className="green-benefits-text" data-aos="fade-right">
          <div className="green-benefits-title9926">
            DIGITAL ACCELERATION<br />
            <span className="green-benefits-title-blue">IN GREEN TECHNOLOGY</span>
          </div>
          <div className="green-benefits-desc">
            The Greentech industry is experiencing phenomenal growth, driven by the urgent need for sustainable practices. Digital solutions are paramount for accelerating this progress.
          </div>
        </div>
        <div className="green-benefits-image" data-aos="fade-left">
          <img src={imageSrc} alt="Digital Acceleration" />
        </div>
      </div>
      <div className="green-benefits-cards">
        {cards.map((card, i) => (
          <div
            className="green-benefits-card"
            key={i}
            data-aos="fade-up"
            data-aos-delay={100 + i * 100}
          >
            <div className="green-benefits-card-icon">{card.icon}</div>
            <div className="green-benefits-card-title">{card.title}</div>
            <div className="green-benefits-card-desc">{card.desc}</div>
          </div>
        ))}
      </div>
      <div className="green-benefits-btn-row" data-aos="fade-up" data-aos-delay="500">
        <button className="green-benefits-btn">
          MORE ABOUT DIGITAL ACCELERATION
        </button>
      </div>
      </div>
    </section>
  );
}